import eventBus from 'EventBus.js';
import BasePropertyView from 'BasePropertyView.js';
import contentTemplate from 'properties/style/screen.ejs';
import outsideColorTemplate from 'properties/style/screen-outsideColor.ejs';
import mobileOutsideColorTemplate from 'properties/style/screen-mobileOutsideColor.ejs';
import $ from 'jquery';
import listService from "../../../service/ListService";
import constants from "../../../constants/Constants";

class StyleScreenView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]': 'updateAttributes',
            'change input[type=color]': 'updateColorAttributes',
            'change input[type=text]': 'updateColorAttributesWithValidation',            
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus'
        };

        return this;
    }

    updateColorAttributesWithValidation(ev) {
        super.updateColorAttributesWithValidation(ev);
        const color = ev.currentTarget.value;

        if (listService.mainKind === constants.KIND_MOBILE) {
            eventBus.trigger('mobileOutsideColorSet', color);
        }  else {
            eventBus.trigger('outsideColorSet', color);
        }
    }

    updateAttributes(ev) {
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.checked;
        this.model.set(propName, propVal);

        if (propName === 'shadow') {
            eventBus.trigger('dropShadowSet', propVal);
        }
    }

    render() {
        super.render();
        this.$el.html(this.template(this.model.toJSON()));

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();

        if (listService.mainKind === constants.KIND_MOBILE) {
            $('#outsideColorPikerContainer').append(mobileOutsideColorTemplate(this.model.toJSON()));
        } else {
            $('#outsideColorPikerContainer').append(outsideColorTemplate(this.model.toJSON()));
        }

        return this;
    }


}

export default StyleScreenView;
